import React, { useContext } from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExpandAlt, faCompressAlt } from "@fortawesome/free-solid-svg-icons"

import Card from "./Card"
import DropDownContext from "./DropDownContext"

const StyledCard = styled(Card)`
  padding: 5px 10px;
`

const HeaderLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;  
`

const SubLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start; 
  margin-bottom: 2px; 
`

const GrayText = styled.span`
  color: var(--gray-text);
`

const BoldText = styled.span`
  font-weight: bold;
`

const SmallText = styled.span`
  font-size: var(--font-sub);
  line-height: var(--line-sub);
`

type NameLineProps = {
  projectname: string
  time: string
}

const NameLine = ({projectname,time}: NameLineProps) => {
  return (
    <HeaderLine>
      <BoldText>{projectname}</BoldText>
      <SmallText>
        <GrayText>{time}</GrayText>
      </SmallText>
    </HeaderLine>
  )
}

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
`

const Icon = styled(FontAwesomeIcon)`
  color: var(--gray-text);
  opacity: 75%;
  user-select: none;
`

type DescriptionLineProps = {
  description: string
  isDropped: boolean
}

const DescriptionLine = ({description, isDropped}: DescriptionLineProps ) => {
  return (
    <SubLine>
      <SmallText>{description}</SmallText>
      <IconContainer>
        <Icon
          icon={isDropped ? faCompressAlt : faExpandAlt }
        />
      </IconContainer>
    </SubLine>
  )
}

type CompanyLineProps = {
  logo: string
  companyname: string
  isDropped: boolean
}

type Props = {
  projectname: string
  description: string
  time: string
}

const CollapsableIndieHead = ({projectname, description, time}: Props) => {
  const { isDropped } = useContext(DropDownContext)

  return (
    <StyledCard>
      <NameLine
        projectname={projectname}
        time={time}/>
      <DescriptionLine
        description={description}
        isDropped={isDropped}/>
    </StyledCard>

      
  )
}

export default CollapsableIndieHead